import { render } from "./addCoupon.vue?vue&type=template&id=9c4fd606&scoped=true&ts=true"
import script from "./addCoupon.vue?vue&type=script&lang=ts"
export * from "./addCoupon.vue?vue&type=script&lang=ts"

import "./addCoupon.vue?vue&type=style&index=0&id=9c4fd606&scoped=true&lang=css"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c4fd606"]])

export default __exports__